import { LoadingOutlined } from '@ant-design/icons';
import { css } from '@linaria/core';
import { Flex, Spin } from 'antd';

const styles = {
  loading: css`
    align-self: stretch;
    min-height: 80vh;
    width: 100%;
  `,
};

const PageLoading = () => (
  <Flex
    className={styles.loading}
    align="center"
    justify="center"
    role="status"
    aria-label="Carregando página"
  >
    <Spin indicator={<LoadingOutlined spin />} size="large" />
  </Flex>
);

export default PageLoading;
